import { styled } from '$utils/theme'
import { Icon } from '$views/components/Icon'
import { Text } from '$views/components'
import { rem } from 'polished'
import { Container } from '$views/components/Layout/Container'

interface Props {
  height: number
}

export const StyledChatNotificationIcon = styled(Icon)<Props>`
  height: 240px;
  position: absolute;
  top: ${p => rem(p.height - 196)};
  left: ${p => rem(p.theme.sizes.small)};
`

export const BannerChatNotification = styled.div<Props>`
  height: ${p => rem(p.height)};
  background-color: ${p => p.theme.colors.xlightPink};
`

export const StyledChatNotificationContainer = styled(Container)`
  top: 0;
  ${p => p.theme.media.desktop`
    padding-left: ${rem(p.theme.sizes.small)};
    padding-right: ${rem(p.theme.sizes.small)};
  `}
  ${p => p.theme.media.onlyMobile`
    padding-top: ${rem(p.theme.sizes.medium)};
  `}
`

export const StyledOptionList = styled.div`
  margin-top: ${p => rem(p.theme.sizes.mini)};
  display: grid;
  grid-template-columns: ${p => rem(p.theme.sizes.medium)} auto;
`

export const StyledNumberList = styled(Text)`
  line-height: 1.1;
`



// WEBPACK FOOTER //
// ./src/views/CaretakerRecommendation/Components/ChatNotification/ChatNotification.style.ts